// API client for AvRi frontend

const API_BASE = '/api';

class APIClient {
  constructor() {
    this.token = localStorage.getItem('avri_auth_token');
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('avri_auth_token', token);
    } else {
      localStorage.removeItem('avri_auth_token');
    }
  }

  getHeaders() {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (this.token) {
      headers.Authorization = `Bearer ${this.token}`;
    }
    
    return headers;
  }

  async request(url, options = {}) {
    const response = await fetch(`${API_BASE}${url}`, {
      ...options,
      headers: {
        ...this.getHeaders(),
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Network error' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return response.json();
  }

  // Authentication
  async requestMagicLink(email, name) {
    return this.request('/auth/request-magic-link', {
      method: 'POST',
      body: JSON.stringify({ email, name }),
    });
  }

  async verifyMagicLink(token) {
    const result = await this.request(`/auth/verify/${token}`);
    this.setToken(result.token);
    return result;
  }

  async getCurrentUser() {
    return this.request('/auth/me');
  }

  async logout() {
    this.setToken(null);
    return { success: true };
  }

  // Household
  async getHouseholdProfile() {
    return this.request('/household/profile');
  }

  async updateHouseholdProfile(profileData) {
    return this.request('/household/profile', {
      method: 'PUT',
      body: JSON.stringify(profileData),
    });
  }

  async updateSavings(currentSavings) {
    return this.request('/household/savings', {
      method: 'PATCH',
      body: JSON.stringify({ current_savings: currentSavings }),
    });
  }

  // Houses
  async getHouses() {
    return this.request('/houses');
  }

  async getHouse(houseId) {
    return this.request(`/houses/${houseId}`);
  }

  async saveHouse(houseData) {
    return this.request('/houses', {
      method: 'POST',
      body: JSON.stringify(houseData),
    });
  }

  async updateHouse(houseId, houseData) {
    return this.request(`/houses/${houseId}`, {
      method: 'PUT',
      body: JSON.stringify(houseData),
    });
  }

  async deleteHouse(houseId) {
    return this.request(`/houses/${houseId}`, {
      method: 'DELETE',
    });
  }

  async addReaction(houseId, reaction) {
    return this.request(`/houses/${houseId}/reaction`, {
      method: 'PATCH',
      body: JSON.stringify({ reaction }),
    });
  }

  async createShareLink(houseId) {
    return this.request(`/houses/${houseId}/share`, {
      method: 'POST',
    });
  }

  // Public share (no auth needed)
  async getShareData(token) {
    return fetch(`${API_BASE}/share/${token}`)
      .then(response => response.json());
  }
}

export const api = new APIClient();
